import { useState, useEffect, useRef } from "react"
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card"
import { Button } from "./ui/button"
import { Input } from "./ui/input"
import { Label } from "./ui/label"
import { Switch } from "./ui/switch"
import { Textarea } from "./ui/textarea"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select"
import { ArrowLeft, Save } from "lucide-react"
import { toast } from 'sonner'
import { useUserRol, useTienePermiso} from '../App';
import { actualizarAceptado, guardarPrueba } from '../services/pruebasService';
import { RechazoModal } from "./RechazoModal";

interface NMXA129453FormData {
  // Parámetros básicos
  fecha: string
  hora: string
  gradosC: string
  porcentajeHR: string
  lavado: string
  secado: string
  
  // Parámetros de ensayo
  tiempoEnsayo: string
  tipoRevest: string
  patronesClas: string
  
  // Dispositivo
  flujoAire: string
  numObservadores: string
  formaEspecimen: string
  
  // Primer Ciclo - Frisas
  frisas_5min_1: string
  frisas_5min_2: string
  frisas_5min_3: string
  frisas_15min_1: string
  frisas_15min_2: string
  frisas_15min_3: string
  frisas_30min_1: string
  frisas_30min_2: string
  frisas_30min_3: string
  // Primer Ciclo - Vellosidad
  vellosidad1_5min_1: string
  vellosidad1_5min_2: string
  vellosidad1_5min_3: string
  vellosidad1_15min_1: string
  vellosidad1_15min_2: string
  vellosidad1_15min_3: string
  vellosidad1_30min_1: string
  vellosidad1_30min_2: string
  vellosidad1_30min_3: string
  // Primer Ciclo - Emarañamiento
  emaranamiento1_5min_1: string
  emaranamiento1_5min_2: string
  emaranamiento1_5min_3: string
  emaranamiento1_15min_1: string
  emaranamiento1_15min_2: string
  emaranamiento1_15min_3: string
  emaranamiento1_30min_1: string
  emaranamiento1_30min_2: string
  emaranamiento1_30min_3: string
  // Segundo Ciclo - Frisas
  frisas2_5min_1: string
  frisas2_5min_2: string
  frisas2_5min_3: string
  frisas2_15min_1: string
  frisas2_15min_2: string
  frisas2_15min_3: string
  frisas2_30min_1: string
  frisas2_30min_2: string
  frisas2_30min_3: string
  // Segundo Ciclo - Vellosidad
  vellosidad2_5min_1: string
  vellosidad2_5min_2: string
  vellosidad2_5min_3: string
  vellosidad2_15min_1: string
  vellosidad2_15min_2: string
  vellosidad2_15min_3: string
  vellosidad2_30min_1: string
  vellosidad2_30min_2: string
  vellosidad2_30min_3: string
  // Segundo Ciclo - Emarañamiento
  emaranamiento2_5min_1: string
  emaranamiento2_5min_2: string
  emaranamiento2_5min_3: string
  emaranamiento2_15min_1: string
  emaranamiento2_15min_2: string
  emaranamiento2_15min_3: string
  emaranamiento2_30min_1: string
  emaranamiento2_30min_2: string
  emaranamiento2_30min_3: string
  // Observaciones y personal
  observaciones: string
  mostrarObservaciones: boolean
  realizo: string
  superviso: string
  // --- NUEVOS CAMPOS ---
  numeroSolicitud?: string
  idTermohigrometro?: string
  // --- NUEVO CAMPO ---
  DESV_METODO?: string;
}

interface NMXA129453FormProps {
  onBack: () => void
  pedidoId: string
  pedidoRowId?: string
  mode: 'create' | 'view' | 'edit'
  initialData?: Partial<NMXA129453FormData>
  realizoUser?: string
  rol?: string // <-- NUEVO: rol del usuario
  onSave?: (data: NMXA129453FormData) => void // <-- AGREGAR onSave opcional
  onRefreshBackend?: () => void;
  onAutosave?: (result: { rowId: string; nomId: string }) => void
}

export function NMXA129453Form({ onBack, pedidoId, pedidoRowId, mode, initialData = {}, realizoUser, rol, onSave, onRefreshBackend, onAutosave }: NMXA129453FormProps) {
  // Support both array and object for initialData
  const initialDataObj = Array.isArray(initialData) ? initialData[0] : initialData;
  const globalRol = useUserRol ? useUserRol() : undefined;
  const puedeRevisar = useTienePermiso('aprobar_rechazar_resultado');
  const effectiveRol = rol || globalRol;
  // Robust logic for accepted/rejected status
  const aceptadoRaw = (initialDataObj as any)?.ACEPTADO ?? (initialDataObj as any)?.aceptado;
  const aceptadoValue = typeof aceptadoRaw === 'string' ? aceptadoRaw.toLowerCase().trim() : '';
  console.log('[NMXA12945-3-Form] initialDataObj:', initialDataObj);
  console.log('[NMXA12945-3-Form] aceptadoRaw:', aceptadoRaw, 'aceptadoValue:', aceptadoValue);
  const isAceptado = aceptadoValue === 'aceptado' || aceptadoValue === 'rechazado';

  const [formData, setFormData] = useState<NMXA129453FormData & { PRUEBA?: string; ROW_ID?: string; numeroSolicitud?: string; idTermohigrometro?: string; DESV_METODO?: string }>({
    fecha: "",
    hora: "",
    gradosC: "",
    porcentajeHR: "",
    lavado: "",
    secado: "",
    
    tiempoEnsayo: "",
    tipoRevest: "",
    patronesClas: "",
    
    flujoAire: "",
    numObservadores: "",
    formaEspecimen: "",
    
    // Primer Ciclo - Frisas
    frisas_5min_1: "", frisas_5min_2: "", frisas_5min_3: "",
    frisas_15min_1: "", frisas_15min_2: "", frisas_15min_3: "",
    frisas_30min_1: "", frisas_30min_2: "", frisas_30min_3: "",
    // Primer Ciclo - Vellosidad
    vellosidad1_5min_1: "", vellosidad1_5min_2: "", vellosidad1_5min_3: "",
    vellosidad1_15min_1: "", vellosidad1_15min_2: "", vellosidad1_15min_3: "",
    vellosidad1_30min_1: "", vellosidad1_30min_2: "", vellosidad1_30min_3: "",
    // Primer Ciclo - Emaranamiento
    emaranamiento1_5min_1: "", emaranamiento1_5min_2: "", emaranamiento1_5min_3: "",
    emaranamiento1_15min_1: "", emaranamiento1_15min_2: "", emaranamiento1_15min_3: "",
    emaranamiento1_30min_1: "", emaranamiento1_30min_2: "", emaranamiento1_30min_3: "",
    // Segundo Ciclo - Frisas
    frisas2_5min_1: "", frisas2_5min_2: "", frisas2_5min_3: "",
    frisas2_15min_1: "", frisas2_15min_2: "", frisas2_15min_3: "",
    frisas2_30min_1: "", frisas2_30min_2: "", frisas2_30min_3: "",
    // Segundo Ciclo - Vellosidad
    vellosidad2_5min_1: "", vellosidad2_5min_2: "", vellosidad2_5min_3: "",
    vellosidad2_15min_1: "", vellosidad2_15min_2: "", vellosidad2_15min_3: "",
    vellosidad2_30min_1: "", vellosidad2_30min_2: "", vellosidad2_30min_3: "",
    // Segundo Ciclo - Emaranamiento
    emaranamiento2_5min_1: "", emaranamiento2_5min_2: "", emaranamiento2_5min_3: "",
    emaranamiento2_15min_1: "", emaranamiento2_15min_2: "", emaranamiento2_15min_3: "",
    emaranamiento2_30min_1: "", emaranamiento2_30min_2: "", emaranamiento2_30min_3: "",
    
    observaciones: "",
    realizo: "",
    superviso: "",
    numeroSolicitud: "",
    idTermohigrometro: "",
    DESV_METODO: (initialDataObj as any)?.DESV_METODO || '',
    ...initialDataObj,
    PRUEBA: (initialDataObj as any)?.PRUEBA || '',
    ROW_ID: (initialDataObj as any)?.ROW_ID || (initialDataObj as any)?.row_id || '',
    mostrarObservaciones: (initialDataObj as any)?.MOSTRAR_OBSERVACIONES === true,
  })

  const [editMode, setEditMode] = useState(false)
  const [estatus, setEstatus] = useState<string>(initialData && (initialData as any).ACEPTADO ? (initialData as any).ACEPTADO : '')

  // Estado para ciclos
  const [numCiclos, setNumCiclos] = useState<'1' | '2'>('2');

  // Estados para el modal de rechazo
  const [rechazoModalOpen, setRechazoModalOpen] = useState(false);
  const [rechazoLoading, setRechazoLoading] = useState(false);

  useEffect(() => {
    if (mode === 'create') {
      setFormData(prev => ({ ...prev, realizo: realizoUser || "" }))
    }
  }, [realizoUser, mode])

  const initialDataSyncedRef = useRef(false)
  useEffect(() => {
    if (initialDataSyncedRef.current) return
    initialDataSyncedRef.current = true
    setFormData(prev => {
      const merged = { ...prev, ...initialDataObj };
      merged.DESV_METODO = (initialDataObj as any)?.DESV_METODO || (initialDataObj as any)?.desv_metodo || prev.DESV_METODO || '';
      merged.PRUEBA = (initialDataObj as any)?.PRUEBA || prev.PRUEBA || '';
      merged.ROW_ID = (initialDataObj as any)?.ROW_ID || (initialDataObj as any)?.row_id || prev.ROW_ID || '';
      merged.mostrarObservaciones = (initialDataObj as any)?.MOSTRAR_OBSERVACIONES === true;
      return merged;
    });
    setEstatus((initialDataObj as any)?.ACEPTADO || '')
    setEditMode(false)
  }, [initialData])

  useEffect(() => {
    if (mode === 'view' && rol !== 'Administrador') {
      setEditMode(false)
    }
  }, [rol, mode])

  // --- Detección automática de ciclos en modo view ---
  useEffect(() => {
    if (mode === 'view') {
      // Detecta si hay datos en el segundo ciclo
      const hasSecondCycle = [
        formData.frisas2_5min_1, formData.frisas2_5min_2, formData.frisas2_5min_3,
        formData.frisas2_15min_1, formData.frisas2_15min_2, formData.frisas2_15min_3,
        formData.frisas2_30min_1, formData.frisas2_30min_2, formData.frisas2_30min_3,
        formData.vellosidad2_5min_1, formData.vellosidad2_5min_2, formData.vellosidad2_5min_3,
        formData.vellosidad2_15min_1, formData.vellosidad2_15min_2, formData.vellosidad2_15min_3,
        formData.vellosidad2_30min_1, formData.vellosidad2_30min_2, formData.vellosidad2_30min_3,
        formData.emaranamiento2_5min_1, formData.emaranamiento2_5min_2, formData.emaranamiento2_5min_3,
        formData.emaranamiento2_15min_1, formData.emaranamiento2_15min_2, formData.emaranamiento2_15min_3,
        formData.emaranamiento2_30min_1, formData.emaranamiento2_30min_2, formData.emaranamiento2_30min_3
      ].some(val => val && String(val).trim() !== "");
      setNumCiclos(hasSecondCycle ? '2' : '1');
    }
  }, [mode, formData]);

  const handleInputChange = (field: keyof NMXA129453FormData, value: any) => {
    setFormData(prev => ({ ...prev, [field]: value }))
  }

  const [guardando, setGuardando] = useState(false)

  const handleSave = async () => {
    if (guardando) return
    setGuardando(true)
    try {
      // Cancela cualquier autoguardado pendiente y espera a que termine el que ya
      // esté en curso, para que el guardado explícito sea siempre el último en
      // escribir (si no, un autoguardado tardío puede revertir esto a "borrador").
      if (autosaveTimerRef.current) { clearTimeout(autosaveTimerRef.current); autosaveTimerRef.current = null }
      while (autosaveInFlightRef.current) {
        await new Promise(r => setTimeout(r, 100))
      }
      // DEBUG: Verifica que se llama y muestra el payload
      console.log('[NMXA129453Form] handleSave called, formData:', formData)
      if (typeof onSave === 'function') {
        onSave(formData)
      } else {
        alert('No se recibió la función onSave para guardar el formulario.')
      }
    } finally {
      setGuardando(false)
    }
  }

  const isReadOnly = mode === 'create' ? false : (mode === 'view' && !editMode);

  const calcularPromedio = (val1: string, val2: string, val3: string): string => {
    const nums = [val1, val2, val3].filter(v => v && !isNaN(parseFloat(v))).map(v => parseFloat(v))
    if (nums.length === 0) return ""
    return (nums.reduce((sum, val) => sum + val, 0) / nums.length).toFixed(2)
  }

  const calcularPromedioRango = (v1: string, v2: string, v3: string): string => {
    const parseRango = (v: string): { min: number; max: number } | null => {
      if (!v) return null
      const parts = v.split('-').map(p => parseFloat(p.trim()))
      if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) return { min: parts[0], max: parts[1] }
      const n = parseFloat(v)
      if (!isNaN(n)) return { min: n, max: n }
      return null
    }
    const rangos = [v1, v2, v3].map(parseRango).filter(r => r !== null) as { min: number; max: number }[]
    if (rangos.length === 0) return ''
    const avgMin = Math.round(rangos.reduce((sum, r) => sum + r.min, 0) / rangos.length)
    const avgMax = Math.round(rangos.reduce((sum, r) => sum + r.max, 0) / rangos.length)
    if (avgMin === avgMax) return String(avgMin)
    return `${avgMin}-${avgMax}`
  }

  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      frisas_5min_promedio: calcularPromedioRango(prev.frisas_5min_1, prev.frisas_5min_2, prev.frisas_5min_3),
      frisas_15min_promedio: calcularPromedioRango(prev.frisas_15min_1, prev.frisas_15min_2, prev.frisas_15min_3),
      frisas_30min_promedio: calcularPromedioRango(prev.frisas_30min_1, prev.frisas_30min_2, prev.frisas_30min_3),
      vellosidad1_5min_promedio: calcularPromedioRango(prev.vellosidad1_5min_1, prev.vellosidad1_5min_2, prev.vellosidad1_5min_3),
      vellosidad1_15min_promedio: calcularPromedioRango(prev.vellosidad1_15min_1, prev.vellosidad1_15min_2, prev.vellosidad1_15min_3),
      vellosidad1_30min_promedio: calcularPromedioRango(prev.vellosidad1_30min_1, prev.vellosidad1_30min_2, prev.vellosidad1_30min_3),
      emaranamiento1_5min_promedio: calcularPromedioRango(prev.emaranamiento1_5min_1, prev.emaranamiento1_5min_2, prev.emaranamiento1_5min_3),
      emaranamiento1_15min_promedio: calcularPromedioRango(prev.emaranamiento1_15min_1, prev.emaranamiento1_15min_2, prev.emaranamiento1_15min_3),
      emaranamiento1_30min_promedio: calcularPromedioRango(prev.emaranamiento1_30min_1, prev.emaranamiento1_30min_2, prev.emaranamiento1_30min_3),
      frisas2_5min_promedio: calcularPromedioRango(prev.frisas2_5min_1, prev.frisas2_5min_2, prev.frisas2_5min_3),
      frisas2_15min_promedio: calcularPromedioRango(prev.frisas2_15min_1, prev.frisas2_15min_2, prev.frisas2_15min_3),
      frisas2_30min_promedio: calcularPromedioRango(prev.frisas2_30min_1, prev.frisas2_30min_2, prev.frisas2_30min_3),
      vellosidad2_5min_promedio: calcularPromedioRango(prev.vellosidad2_5min_1, prev.vellosidad2_5min_2, prev.vellosidad2_5min_3),
      vellosidad2_15min_promedio: calcularPromedioRango(prev.vellosidad2_15min_1, prev.vellosidad2_15min_2, prev.vellosidad2_15min_3),
      vellosidad2_30min_promedio: calcularPromedioRango(prev.vellosidad2_30min_1, prev.vellosidad2_30min_2, prev.vellosidad2_30min_3),
      emaranamiento2_5min_promedio: calcularPromedioRango(prev.emaranamiento2_5min_1, prev.emaranamiento2_5min_2, prev.emaranamiento2_5min_3),
      emaranamiento2_15min_promedio: calcularPromedioRango(prev.emaranamiento2_15min_1, prev.emaranamiento2_15min_2, prev.emaranamiento2_15min_3),
      emaranamiento2_30min_promedio: calcularPromedioRango(prev.emaranamiento2_30min_1, prev.emaranamiento2_30min_2, prev.emaranamiento2_30min_3),
    } as any))
  }, [
    formData.frisas_5min_1, formData.frisas_5min_2, formData.frisas_5min_3,
    formData.frisas_15min_1, formData.frisas_15min_2, formData.frisas_15min_3,
    formData.frisas_30min_1, formData.frisas_30min_2, formData.frisas_30min_3,
    formData.vellosidad1_5min_1, formData.vellosidad1_5min_2, formData.vellosidad1_5min_3,
    formData.vellosidad1_15min_1, formData.vellosidad1_15min_2, formData.vellosidad1_15min_3,
    formData.vellosidad1_30min_1, formData.vellosidad1_30min_2, formData.vellosidad1_30min_3,
    formData.emaranamiento1_5min_1, formData.emaranamiento1_5min_2, formData.emaranamiento1_5min_3,
    formData.emaranamiento1_15min_1, formData.emaranamiento1_15min_2, formData.emaranamiento1_15min_3,
    formData.emaranamiento1_30min_1, formData.emaranamiento1_30min_2, formData.emaranamiento1_30min_3,
    formData.frisas2_5min_1, formData.frisas2_5min_2, formData.frisas2_5min_3,
    formData.frisas2_15min_1, formData.frisas2_15min_2, formData.frisas2_15min_3,
    formData.frisas2_30min_1, formData.frisas2_30min_2, formData.frisas2_30min_3,
    formData.vellosidad2_5min_1, formData.vellosidad2_5min_2, formData.vellosidad2_5min_3,
    formData.vellosidad2_15min_1, formData.vellosidad2_15min_2, formData.vellosidad2_15min_3,
    formData.vellosidad2_30min_1, formData.vellosidad2_30min_2, formData.vellosidad2_30min_3,
    formData.emaranamiento2_5min_1, formData.emaranamiento2_5min_2, formData.emaranamiento2_5min_3,
    formData.emaranamiento2_15min_1, formData.emaranamiento2_15min_2, formData.emaranamiento2_15min_3,
    formData.emaranamiento2_30min_1, formData.emaranamiento2_30min_2, formData.emaranamiento2_30min_3,
  ])

  // Ahora el payload SIEMPRE toma PRUEBA y ROW_ID de formData
  const [autosaveRowId, setAutosaveRowId] = useState<string>(
    (formData as any)?.ROW_ID || (initialDataObj as any)?.ROW_ID || (initialDataObj as any)?.row_id || ''
  )
  const [autosaveNomId, setAutosaveNomId] = useState<string>((initialDataObj as any)?.nomId || '')
  const rowId = autosaveRowId;
  const nomId = autosaveNomId;
  const pedidoValue = (formData as any).PEDIDO || pedidoId || '';
  const pruebaValue = (formData as any).PRUEBA || (initialDataObj as any)?.PRUEBA || '';

  const formPayload = () => {
    const { ROW_ID, PRUEBA, PEDIDO, ...rest } = formData as any
    return rest
  }

  // ── Autosave (borrador) ──────────────────────────────────────────────────
  const autosaveTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const isFirstAutosaveRenderRef = useRef(true)
  const autosaveInFlightRef = useRef(false)
  const rowIdRef = useRef(rowId)
  const nomIdRef = useRef(nomId)
  useEffect(() => { rowIdRef.current = rowId }, [rowId])
  useEffect(() => { nomIdRef.current = nomId }, [nomId])

  const doAutosave = async () => {
    if (autosaveInFlightRef.current) return
    autosaveInFlightRef.current = true
    try {
      const { pruebaId, nomId: savedNomId } = await guardarPrueba(
        'NMX-A-12945-3-INNTEX-2020 DETERMINACIÓN DE FRISAS, VELLOSIDAD Y EMARAÑAMIENTO',
        pedidoRowId || '',
        formPayload(),
        nomIdRef.current || undefined,
        rowIdRef.current || undefined,
        true,
      )
      setAutosaveRowId(String(pruebaId))
      setAutosaveNomId(savedNomId)
      rowIdRef.current = String(pruebaId)
      nomIdRef.current = savedNomId
      onAutosave?.({ rowId: String(pruebaId), nomId: savedNomId })
    } catch (err) {
      console.warn('Autosave de borrador falló (silencioso):', err)
    } finally {
      autosaveInFlightRef.current = false
    }
  }

  useEffect(() => {
    if (isFirstAutosaveRenderRef.current) {
      isFirstAutosaveRenderRef.current = false
      return
    }
    if (mode === 'view' || isAceptado) return

    if (autosaveTimerRef.current) clearTimeout(autosaveTimerRef.current)
    autosaveTimerRef.current = setTimeout(() => {
      autosaveTimerRef.current = null
      doAutosave()
    }, 1500)

    return () => {
      if (autosaveTimerRef.current) clearTimeout(autosaveTimerRef.current)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData, mode, isAceptado])

  // Si hay un autoguardado pendiente (debounce de 1.5s) y el usuario navega hacia
  // atrás antes de que se dispare, se cancelaba sin guardarse nunca. Al salir,
  // se ejecuta de inmediato ese guardado pendiente con los datos más recientes.
  const handleBackFlush = () => {
    if (autosaveTimerRef.current) {
      clearTimeout(autosaveTimerRef.current)
      autosaveTimerRef.current = null
      if (mode !== 'view' && !isAceptado) {
        doAutosave()
      }
    }
    onBack()
  }

  const handleAccion = async (accion: 'aceptado' | 'rechazado') => {
    const confirmMsg = accion === 'aceptado'
      ? 'Al continuar, esta acción no podrá editarse ni borrarse. ¿Estás seguro de que quieres aceptar la prueba NMX-A-12945-3?'
      : 'Al continuar, esta acción no podrá editarse ni borrarse. ¿Estás seguro de que quieres rechazar la prueba NMX-A-12945-3?';
    if (!window.confirm(confirmMsg)) return;
    const payload = {
      ...formData,
      ROW_ID: rowId,
      PEDIDO: rowId, // <-- ahora PEDIDO manda el ROW_ID
      PRUEBA: pruebaValue,
      superviso: realizoUser || formData.superviso || '',
      usuario: realizoUser,
      ACEPTAR: accion === 'aceptado' ? 'aceptado' : 'rechazado',
      ACEPTADO: accion
    };
    try {
      // Evita que un autoguardado pendiente o en vuelo se resuelva despues de
      // aceptar/rechazar y revierta `estado` a 'borrador' (ver guardarPrueba en pruebasService.ts).
      if (autosaveTimerRef.current) { clearTimeout(autosaveTimerRef.current); autosaveTimerRef.current = null }
      while (autosaveInFlightRef.current) { await new Promise(r => setTimeout(r, 100)) }
      await actualizarAceptado(rowId, accion, undefined, (payload as any).superviso, nomId);
      setEstatus(payload.ACEPTAR);
      setEditMode(false);
      toast.success(`Prueba ${accion === 'aceptado' ? 'aceptada' : 'rechazada'} correctamente.`);
      if (typeof onRefreshBackend === 'function') setTimeout(() => onRefreshBackend(), 300);
    } catch (err: any) {
      alert('Error al enviar al backend: ' + (err.message || err));
    }
  };

  const handleRechazar = () => setRechazoModalOpen(true);

  const handleRechazoSubmit = async (razon: string) => {
    setRechazoLoading(true);
    const confirmMsg = 'Al continuar, esta acción no podrá editarse ni borrarse. ¿Estás seguro de que quieres rechazar la prueba NMX-A-12945-3?';
    if (!window.confirm(confirmMsg)) {
      setRechazoLoading(false);
      setRechazoModalOpen(false);
      return;
    }
    const payload = {
      ...formData,
      ROW_ID: rowId,
      PEDIDO: rowId, // <-- ahora PEDIDO manda el ROW_ID
      PRUEBA: pruebaValue,
      superviso: realizoUser || formData.superviso || '',
      usuario: realizoUser,
      ACEPTAR: 'rechazado',
      ACEPTADO: 'rechazado',
      RAZON_RECHAZO: razon
    };
    try {
      // Evita que un autoguardado pendiente o en vuelo se resuelva despues de
      // aceptar/rechazar y revierta `estado` a 'borrador' (ver guardarPrueba en pruebasService.ts).
      if (autosaveTimerRef.current) { clearTimeout(autosaveTimerRef.current); autosaveTimerRef.current = null }
      while (autosaveInFlightRef.current) { await new Promise(r => setTimeout(r, 100)) }
      await actualizarAceptado(rowId, 'rechazado', razon, undefined, nomId);
      setEstatus('rechazado');
      setEditMode(false);
      setRechazoModalOpen(false);
      toast.success('Prueba rechazada correctamente.');
      if (typeof onRefreshBackend === 'function') setTimeout(() => onRefreshBackend(), 300);
    } catch (err: any) {
      alert('Error al enviar al backend: ' + (err.message || err));
    } finally {
      setRechazoLoading(false);
    }
  };

  const handleEditar = () => {
    setEditMode(true)
  }

  const handleGuardarEdicion = async () => {
    if (!window.confirm('¿Seguro que quieres guardar y aceptar la edición de NMX-A-12945-3? Esta acción no se puede deshacer.')) return;
    const payload = {
      ...formData,
      ROW_ID: rowId,
      PEDIDO: rowId, // <-- ahora PEDIDO manda el ROW_ID
      PRUEBA: pruebaValue,
      superviso: realizoUser || formData.superviso || '',
      usuario: realizoUser,
      ACEPTAR: 'aceptado',
      ACEPTADO: 'aceptado'
    };
    try {
      onSave({ ...payload, _EDIT_MODE: true } as any);
    } catch (err) {
      console.error('Error al guardar edición:', err);
    }
  }

  const renderCycleTable = (cycleNumber: 1 | 2, title: string) => {
    // For frisas: '' for first cycle, '2' for second cycle
    // For vellosidad/emaranamiento: '1' for first cycle, '2' for second cycle
    const frisasPrefix = cycleNumber === 1 ? '' : '2';
    const vellEmPrefix = cycleNumber === 1 ? '1' : '2';
    return (
      <Card className="mb-6">
        <CardHeader className="pb-3">
          <CardTitle className="text-primary text-center">{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="overflow-x-auto">
            <table className="w-full border border-border text-xs">
              <thead>
                <tr className="bg-muted">
                  <th className="border border-border p-2 text-center font-medium">TIEMPO</th>
                  <th className="border border-border p-2 text-center font-medium" colSpan={4}>FRISAS</th>
                  <th className="border border-border p-2 text-center font-medium" colSpan={4}>VELLOSIDAD</th>
                  <th className="border border-border p-2 text-center font-medium" colSpan={4}>EMARAÑAMIENTO</th>
                </tr>
                <tr className="bg-muted">
                  <th className="border border-border p-2 text-center font-medium">NO. DE<br/>ESPECIMEN</th>
                  <th className="border border-border p-2 text-center font-medium">1</th>
                  <th className="border border-border p-2 text-center font-medium">2</th>
                  <th className="border border-border p-2 text-center font-medium">3</th>
                  <th className="border border-border p-2 text-center font-medium">PROME<br/>DIO</th>
                  <th className="border border-border p-2 text-center font-medium">1</th>
                  <th className="border border-border p-2 text-center font-medium">2</th>
                  <th className="border border-border p-2 text-center font-medium">3</th>
                  <th className="border border-border p-2 text-center font-medium">PROME<br/>DIO</th>
                  <th className="border border-border p-2 text-center font-medium">1</th>
                  <th className="border border-border p-2 text-center font-medium">2</th>
                  <th className="border border-border p-2 text-center font-medium">3</th>
                  <th className="border border-border p-2 text-center font-medium">PROME<br/>DIO</th>
                </tr>
              </thead>
              <tbody>
                {['5', '15', '30'].map((tiempo) => (
                  <tr key={tiempo}>
                    <td className="border border-border p-2 text-center font-medium bg-muted">
                      {tiempo} MINS
                    </td>
                    {/* Frisas */}
                    <td className="border border-border p-1">
                      <Input
                        type="text"
                        value={formData[`frisas${frisasPrefix}_${tiempo}min_1` as keyof NMXA129453FormData] as string}
                        onChange={(e) => handleInputChange(`frisas${frisasPrefix}_${tiempo}min_1` as keyof NMXA129453FormData, e.target.value)}
                        disabled={isReadOnly}
                        className="text-center border-0 bg-transparent text-xs"
                      />
                    </td>
                    <td className="border border-border p-1">
                      <Input
                        type="text"
                        value={formData[`frisas${frisasPrefix}_${tiempo}min_2` as keyof NMXA129453FormData] as string}
                        onChange={(e) => handleInputChange(`frisas${frisasPrefix}_${tiempo}min_2` as keyof NMXA129453FormData, e.target.value)}
                        disabled={isReadOnly}
                        className="text-center border-0 bg-transparent text-xs"
                      />
                    </td>
                    <td className="border border-border p-1">
                      <Input
                        type="text"
                        value={formData[`frisas${frisasPrefix}_${tiempo}min_3` as keyof NMXA129453FormData] as string}
                        onChange={(e) => handleInputChange(`frisas${frisasPrefix}_${tiempo}min_3` as keyof NMXA129453FormData, e.target.value)}
                        disabled={isReadOnly}
                        className="text-center border-0 bg-transparent text-xs"
                      />
                    </td>
                    <td className="border border-border p-2 text-center bg-accent text-xs">
                      <Input
                        type="text"
                        value={(formData as any)[`frisas${frisasPrefix}_${tiempo}min_promedio`] || ''}
                        onChange={(e) => handleInputChange(`frisas${frisasPrefix}_${tiempo}min_promedio` as keyof NMXA129453FormData, e.target.value)}
                        disabled={isReadOnly}
                        className="text-center border-0 bg-transparent text-xs"
                      />
                    </td>
                    {/* Vellosidad */}
                    <td className="border border-border p-1">
                      <Input
                        type="text"
                        value={formData[`vellosidad${vellEmPrefix}_${tiempo}min_1` as keyof NMXA129453FormData] as string}
                        onChange={(e) => handleInputChange(`vellosidad${vellEmPrefix}_${tiempo}min_1` as keyof NMXA129453FormData, e.target.value)}
                        disabled={isReadOnly}
                        className="text-center border-0 bg-transparent text-xs"
                      />
                    </td>
                    <td className="border border-border p-1">
                      <Input
                        type="text"
                        value={formData[`vellosidad${vellEmPrefix}_${tiempo}min_2` as keyof NMXA129453FormData] as string}
                        onChange={(e) => handleInputChange(`vellosidad${vellEmPrefix}_${tiempo}min_2` as keyof NMXA129453FormData, e.target.value)}
                        disabled={isReadOnly}
                        className="text-center border-0 bg-transparent text-xs"
                      />
                    </td>
                    <td className="border border-border p-1">
                      <Input
                        type="text"
                        value={formData[`vellosidad${vellEmPrefix}_${tiempo}min_3` as keyof NMXA129453FormData] as string}
                        onChange={(e) => handleInputChange(`vellosidad${vellEmPrefix}_${tiempo}min_3` as keyof NMXA129453FormData, e.target.value)}
                        disabled={isReadOnly}
                        className="text-center border-0 bg-transparent text-xs"
                      />
                    </td>
                    <td className="border border-border p-2 text-center bg-accent text-xs">
                      <Input
                        type="text"
                        value={(formData as any)[`vellosidad${vellEmPrefix}_${tiempo}min_promedio`] || ''}
                        onChange={(e) => handleInputChange(`vellosidad${vellEmPrefix}_${tiempo}min_promedio` as keyof NMXA129453FormData, e.target.value)}
                        disabled={isReadOnly}
                        className="text-center border-0 bg-transparent text-xs"
                      />
                    </td>
                    {/* Emarañamiento */}
                    <td className="border border-border p-1">
                      <Input
                        type="text"
                        value={formData[`emaranamiento${vellEmPrefix}_${tiempo}min_1` as keyof NMXA129453FormData] as string}
                        onChange={(e) => handleInputChange(`emaranamiento${vellEmPrefix}_${tiempo}min_1` as keyof NMXA129453FormData, e.target.value)}
                        disabled={isReadOnly}
                        className="text-center border-0 bg-transparent text-xs"
                      />
                    </td>
                    <td className="border border-border p-1">
                      <Input
                        type="text"
                        value={formData[`emaranamiento${vellEmPrefix}_${tiempo}min_2` as keyof NMXA129453FormData] as string}
                        onChange={(e) => handleInputChange(`emaranamiento${vellEmPrefix}_${tiempo}min_2` as keyof NMXA129453FormData, e.target.value)}
                        disabled={isReadOnly}
                        className="text-center border-0 bg-transparent text-xs"
                      />
                    </td>
                    <td className="border border-border p-1">
                      <Input
                        type="text"
                        value={formData[`emaranamiento${vellEmPrefix}_${tiempo}min_3` as keyof NMXA129453FormData] as string}
                        onChange={(e) => handleInputChange(`emaranamiento${vellEmPrefix}_${tiempo}min_3` as keyof NMXA129453FormData, e.target.value)}
                        disabled={isReadOnly}
                        className="text-center border-0 bg-transparent text-xs"
                      />
                    </td>
                    <td className="border border-border p-2 text-center bg-accent text-xs">
                      <Input
                        type="text"
                        value={(formData as any)[`emaranamiento${vellEmPrefix}_${tiempo}min_promedio`] || ''}
                        onChange={(e) => handleInputChange(`emaranamiento${vellEmPrefix}_${tiempo}min_promedio` as keyof NMXA129453FormData, e.target.value)}
                        disabled={isReadOnly}
                        className="text-center border-0 bg-transparent text-xs"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    )
  }

  return (
    <div className="min-h-screen bg-background p-6">
      {/* Modal de rechazo */}
      <RechazoModal
        open={rechazoModalOpen}
        onClose={() => setRechazoModalOpen(false)}
        onSubmit={handleRechazoSubmit}
        loading={rechazoLoading}
      />
      <div className="max-w-7xl mx-auto space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Button variant="outline" size="icon" onClick={handleBackFlush}>
              <ArrowLeft className="w-4 h-4" />
            </Button>
            <div>
              <h1 className="text-2xl font-semibold text-foreground">
                NMX-A-12945-3-INNTEX-2020
              </h1>
              <p className="text-muted-foreground">
                DETERMINACIÓN DE LA PROPENSIÓN DE LA SUPERFICIE DE LA TELA AL FRISADO, VELLOSIDAD Y EMARAÑAMIENTO
              </p>
              <p className="text-sm text-primary font-medium mt-1">Método: MET-7.2-16</p>
            </div>
          </div>
        </div>

        {/* Información del Pedido */}
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-primary">Información del Pedido</CardTitle>
          </CardHeader>
          <CardContent>
            {/* Pedido No arriba */}
            <div className="mb-2">
              <p className="text-sm text-muted-foreground font-semibold">Pedido No: {pedidoId}</p>
            </div>
            {/* Dos campos en una fila */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-end">
              <div>
                <Label htmlFor="numeroSolicitud">Número de solicitud</Label>
                <Input
                  id="numeroSolicitud"
                  type="text"
                  placeholder="Ingrese el número de solicitud"
                  value={formData.numeroSolicitud || ""}
                  onChange={(e) => handleInputChange('numeroSolicitud', e.target.value)}
                  disabled={isReadOnly}
                  className="mt-2"
                />
              </div>
              <div>
                <Label htmlFor="idTermohigrometro">ID de termohigrómetro</Label>
                <Select
                  value={formData.idTermohigrometro || ""}
                  onValueChange={(value) => handleInputChange('idTermohigrometro', value)}
                  disabled={isReadOnly}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Seleccione ID" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="E-59">E-59</SelectItem>
                    <SelectItem value="E-57">E-57</SelectItem>
                    <SelectItem value="E-56">E-56</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Parámetros de Prueba */}
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-primary">Parámetros de Prueba</CardTitle>
          </CardHeader>
          <CardContent>
            {/* Selector de ciclos SOLO editable si no es view */}
            <div className="mb-6 flex items-center gap-6">
              <Label className="text-base font-medium">Número de ciclos:</Label>
              <div className="flex gap-4">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="numCiclos"
                    value="1"
                    checked={numCiclos === '1'}
                    onChange={() => setNumCiclos('1')}
                    className="accent-primary"
                    disabled={mode === 'view'}
                  />
                  <span>1 ciclo</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="numCiclos"
                    value="2"
                    checked={numCiclos === '2'}
                    onChange={() => setNumCiclos('2')}
                    className="accent-primary"
                    disabled={mode === 'view'}
                  />
                  <span>2 ciclos</span>
                </label>
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full border border-border text-sm">
                <thead>
                  <tr className="bg-muted">
                    <th className="border border-border p-2 text-left font-medium">FECHA:</th>
                    <th className="border border-border p-2 text-left font-medium">HORA:</th>
                    <th className="border border-border p-2 text-left font-medium">°C:</th>
                    <th className="border border-border p-2 text-left font-medium">% HR:</th>
                    <th className="border border-border p-2 text-left font-medium">LAVADO:</th>
                    <th className="border border-border p-2 text-left font-medium">SECADO:</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-border p-1">
                      <Input
                        type="date"
                        value={formData.fecha}
                        onChange={(e) => handleInputChange('fecha', e.target.value)}
                        disabled={isReadOnly}
                      />
                    </td>
                    <td className="border border-border p-1">
                      <Input
                        type="time"
                        value={formData.hora}
                        onChange={(e) => { if (e.target.value) handleInputChange('hora', e.target.value) }}
                        disabled={isReadOnly}
                      />
                    </td>
                    <td className="border border-border p-1">
                      <Input
                        type="number"
                        step="0.1"
                        placeholder="°C"
                        value={formData.gradosC}
                        onChange={(e) => handleInputChange('gradosC', e.target.value)}
                        disabled={isReadOnly}
                      />
                    </td>
                    <td className="border border-border p-1">
                      <Input
                        type="number"
                        step="0.1"
                        placeholder="%"
                        value={formData.porcentajeHR}
                        onChange={(e) => handleInputChange('porcentajeHR', e.target.value)}
                        disabled={isReadOnly}
                      />
                    </td>
                    <td className="border border-border p-1">
                      <Select value={formData.lavado} onValueChange={(value) => handleInputChange('lavado', value)} disabled={isReadOnly}>
                        <SelectTrigger>
                          <SelectValue placeholder="Lavado" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="N/A">N/A</SelectItem>
                          <SelectItem value="1B">1B</SelectItem>
                          <SelectItem value="2B">2B</SelectItem>
                          <SelectItem value="3B">3B</SelectItem>
                          <SelectItem value="4B">4B</SelectItem>
                          <SelectItem value="5B">5B</SelectItem>
                          <SelectItem value="6B">6B</SelectItem>
                          <SelectItem value="7B">7B</SelectItem>
                          <SelectItem value="8B">8B</SelectItem>
                          <SelectItem value="9B">9B</SelectItem>
                          <SelectItem value="10B">10B</SelectItem>
                          <SelectItem value="11B">11B</SelectItem>
                        </SelectContent>
                      </Select>
                    </td>
                    <td className="border border-border p-1">
                      <Select value={formData.secado} onValueChange={(value) => handleInputChange('secado', value)} disabled={isReadOnly}>
                        <SelectTrigger>
                          <SelectValue placeholder="Secado" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="N/A">N/A</SelectItem>
                          <SelectItem value="Procedimiento A – Secado en línea">Procedimiento A – Secado en línea</SelectItem>
                          <SelectItem value="Procedimiento B – Secado por escurrimiento">Procedimiento B – Secado por escurrimiento</SelectItem>
                          <SelectItem value="Procedimiento C – Secado en rejilla">Procedimiento C – Secado en rejilla</SelectItem>
                          <SelectItem value="Procedimiento D – Secado escurrimiento horizontal">Procedimiento D – Secado escurrimiento horizontal</SelectItem>
                          <SelectItem value="Procedimiento F – Secado en tómbola">Procedimiento F – Secado en tómbola</SelectItem>
                        </SelectContent>
                      </Select>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Segunda fila de parámetros */}
            <div className="mt-4 overflow-x-auto">
              <table className="w-full border border-border text-sm">
                <thead>
                  <tr className="bg-muted">
                    <th className="border border-border p-2 text-left font-medium">TIEMPO DE<br/>ENSAYO:</th>
                    <th className="border border-border p-2 text-left font-medium">TIPO DE<br/>REVEST:</th>
                    <th className="border border-border p-2 text-left font-medium">PATRONES<br/>CLASIF:</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-border p-1">
                      <Select value={formData.tiempoEnsayo} onValueChange={(value) => handleInputChange('tiempoEnsayo', value)} disabled={isReadOnly}>
                        <SelectTrigger>
                          <SelectValue placeholder="Tiempo" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="15 min">15 min</SelectItem>
                          <SelectItem value="30 min">30 min</SelectItem>
                          <SelectItem value="45 min">45 min</SelectItem>
                          <SelectItem value="60 min">60 min</SelectItem>
                          <SelectItem value="90 min">90 min</SelectItem>
                          <SelectItem value="120 min">120 min</SelectItem>
                        </SelectContent>
                      </Select>
                    </td>
                    <td className="border border-border p-1">
                      <Select value={formData.tipoRevest} onValueChange={(value) => handleInputChange('tipoRevest', value)} disabled={isReadOnly}>
                        <SelectTrigger>
                          <SelectValue placeholder="Tipo de revestimiento" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="CORCHO">CORCHO</SelectItem>
                          <SelectItem value="POLICLOROPRENO">POLICLOROPRENO</SelectItem>
                        </SelectContent>
                      </Select>
                    </td>
                    <td className="border border-border p-1">
                      <Input
                        type="text"
                        placeholder="Patrones clasificación"
                        value={formData.patronesClas}
                        onChange={(e) => handleInputChange('patronesClas', e.target.value)}
                        disabled={isReadOnly}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Tercera fila de parámetros */}
            <div className="mt-4 overflow-x-auto">
              <table className="w-full border border-border text-sm">
                <thead>
                  <tr className="bg-muted">
                    <th className="border border-border p-2 text-left font-medium">DISPOSITIVO:<br/></th>
                    <th className="border border-border p-2 text-left font-medium">NO. DE<br/>OBSERVADORES:</th>
                    <th className="border border-border p-2 text-left font-medium">FORMA DE<br/>ESPÉCIMEN:</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-border p-1">
                      <Select value={formData.flujoAire} onValueChange={(value) => handleInputChange('flujoAire', value)} disabled={isReadOnly}>
                        <SelectTrigger>
                          <SelectValue placeholder="Dispositivo" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="Flujo de Aire">Flujo de Aire</SelectItem>
                          <SelectItem value="ASPAS DE PLASTICO">ASPAS DE PLASTICO</SelectItem>
                        </SelectContent>
                      </Select>
                    </td>
                    <td className="border border-border p-1">
                      <Input
                        type="number"
                        placeholder="Número"
                        value={formData.numObservadores}
                        onChange={(e) => handleInputChange('numObservadores', e.target.value)}
                        disabled={isReadOnly}
                      />
                    </td>
                    <td className="border border-border p-1">
                      <Select value={formData.formaEspecimen} onValueChange={(value) => handleInputChange('formaEspecimen', value)} disabled={isReadOnly}>
                        <SelectTrigger>
                          <SelectValue placeholder="Forma" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="CÍRCULO">CÍRCULO</SelectItem>
                          <SelectItem value="CUADRADO">CUADRADO</SelectItem>
                        </SelectContent>
                      </Select>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Campo Desviación al método */}
            <div className="mt-4">
              <Label htmlFor="desvMetodo">Desviación al método</Label>
              <Input
                id="desvMetodo"
                type="text"
                placeholder="Ingrese la desviación al método"
                value={formData.DESV_METODO || ""}
                onChange={(e) => handleInputChange('DESV_METODO', e.target.value)}
                disabled={isReadOnly}
                className="mt-2"
              />
            </div>
          </CardContent>
        </Card>

        {/* Primer Ciclo */}
        {renderCycleTable(1, "PRIMER CICLO")}
        {/* Segundo Ciclo SOLO si numCiclos === '2' */}
        {numCiclos === '2' && renderCycleTable(2, "SEGUNDO CICLO")}

        {/* Observaciones y Firmas */}
        <div className="grid grid-cols-1 gap-6">
          {/* Observaciones */}
          <Card>
            <CardHeader className="pb-3 flex flex-row items-center justify-between">
              <CardTitle className="text-primary">Observaciones</CardTitle>
              <span className="flex items-center gap-1.5 text-xs text-muted-foreground">
                Mostrar en Reporte Cliente
                <Switch checked={formData.mostrarObservaciones === true} disabled={isReadOnly}
                  onCheckedChange={(checked) => handleInputChange('mostrarObservaciones', checked)} />
              </span>
            </CardHeader>
            <CardContent>
              <div>
                <Label htmlFor="observaciones">OBSERVACIONES:</Label>
                <Textarea
                  id="observaciones"
                  placeholder="Ingrese las observaciones aquí..."
                  value={formData.observaciones}
                  onChange={(e) => handleInputChange('observaciones', e.target.value)}
                  disabled={isReadOnly}
                  className="mt-2 min-h-[100px]"
                />
              </div>
            </CardContent>
          </Card>

          {/* Firmas */}
          <Card>
            <CardHeader className="pb-3">
              <CardTitle className="text-primary">Firmas</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <Label htmlFor="realizo">REALIZÓ:</Label>
                  <Input
                    id="realizo"
                    type="text"
                    placeholder="Nombre de quien realizó"
                    value={formData.realizo}
                    readOnly
                    className="mt-2 bg-muted-foreground/10 cursor-not-allowed"
                  />
                </div>
                <div>
                  <Label htmlFor="superviso">SUPERVISÓ:</Label>
                  <Input
                    id="superviso"
                    type="text"
                    placeholder="Nombre de quien supervisó"
                    value={formData.superviso}
                    readOnly
                    className="mt-2 bg-muted-foreground/10 cursor-not-allowed"
                  />
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="flex justify-end gap-4">
          <Button variant="outline" onClick={handleBackFlush}>
            Cancelar
          </Button>
          {/* Botones de acciones en modo view y no aceptado SOLO PARA ADMIN */}
          {mode === 'view' && !editMode && !isAceptado && puedeRevisar && (
            <>
              <Button variant="default" onClick={() => handleAccion('aceptado')}>Aceptar</Button>
              <Button variant="destructive" onClick={handleRechazar}>Rechazar</Button>
              <Button variant="secondary" onClick={handleEditar}>Editar</Button>
            </>
          )}
          {/* Botón guardar edición SOLO PARA ADMIN */}
          {mode === 'view' && editMode && !isAceptado && puedeRevisar && (
            <Button variant="default" onClick={handleGuardarEdicion}>
              <Save className="h-4 w-4 mr-2" />
              Guardar Edición
            </Button>
          )}
          {/* Botón guardar en modo create */}
          {mode === 'create' && (
            <Button onClick={handleSave} disabled={guardando}>
              <Save className="h-4 w-4 mr-2" />
              {guardando ? 'Guardando...' : 'Guardar Formulario'}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}